module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "icon icon-left pull-left",
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("修改收货信息")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("收货人")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.consignee),
      expression: "expressInfo.consignee",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "text"
    },
    domProps: {
      "value": (_vm.expressInfo.consignee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "consignee", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.expressMobile),
      expression: "expressInfo.expressMobile",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.expressInfo.expressMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "expressMobile", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("详细地址")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.expressAddress),
      expression: "expressInfo.expressAddress",
      modifiers: {
        "trim": true
      }
    }],
    domProps: {
      "value": (_vm.expressInfo.expressAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "expressAddress", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("默认状态")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    staticStyle: {
      "margin-top": "1px",
      "margin-left": "45%"
    }
  }, [_c('label', {
    staticClass: "label-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expressInfo.isDefault),
      expression: "expressInfo.isDefault"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.expressInfo.isDefault) ? _vm._i(_vm.expressInfo.isDefault, null) > -1 : (_vm.expressInfo.isDefault)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.expressInfo.isDefault,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.expressInfo, "isDefault", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.expressInfo, "isDefault", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.expressInfo, "isDefault", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-100"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    attrs: {
      "href": _vm.href
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认修改")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-100"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-danger",
    attrs: {
      "href": _vm.href
    },
    on: {
      "click": _vm.delAddress
    }
  }, [_vm._v("删除地址")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "align-top"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "id": "city-picker"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f89e6cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/MyInvoice/InvoiceAddressModify.vue
// module id = 1587
// module chunks = 8